<!-- <div id="mySidenav" *ngIf="sidenav" class="sidenav">
  <a href="javascript:void(0)" class="closebtn" (click)="closeNav()">&times;</a>
  <a href="#">About</a>
  <a href="#">Services</a>
  <a href="#">Clients</a>
  <a href="#">Contact</a>
</div>
<div>
  <span style="font-size:30px;cursor:pointer" (click)="openNav()">&#9776; QUBES</span>
</div> -->
<app-card [hidHeader]="true" style="width: 600px;">
  <custom-table [tableDatas]="tableDatas" [tableColumns]="tableColumns" ></custom-table>
  </app-card>